
<template>
  	<LayoutView/>
</template>

<!-- // // // //  -->

<script>

import LayoutView from './components/layout.vue'

export default {
  components: {
    LayoutView
  }
}
</script>





// WEBPACK FOOTER //
// src/containers/app_notification/index.vue